module.exports = "/_next/static/images/truck3-43ecedc7e7d93cd648c59bf1b1837038.png.webp";